import Swiper from "swiper";

window.Swiper = Swiper;

window.CurrentCountryID = "id";
window.OpenPanelsList = [];
window.DropDownInsideContainer = null;
window.AnimateBlockerDuration = 150;


// =============================== ANIMATE PANEL INSIDE ===========================

window.MovePanelInsideContainerNext = function(CurrentPanel, NextPanel, whichcontainer, functiontocall)
{
    whichcontainer.style.overflow = "hidden";

    if(CurrentPanel != null)
    {
        CurrentPanel.style.opacity = 0;
        CurrentPanel.style.left = "-15%";
        CurrentPanel.animate([{opacity: 1, left: "0%"},{opacity: 0, left: "-15%"}], {duration: window.AnimateBlockerDuration});
    }
    else
    {
        whichcontainer.style.opacity = 0;
    }

    setTimeout(function()
    {
        if(CurrentPanel != null)
        {
            CurrentPanel.style.position = "absolute";
            CurrentPanel.style.display = "none";
            CurrentPanel.style.left = "-105%";
        }
        else
        {
            whichcontainer.style.opacity = 1;
            whichcontainer.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateBlockerDuration});
        }

        NextPanel.style.opacity = 1;
        NextPanel.style.left = "0%";
        NextPanel.style.position = "relative";
        NextPanel.style.display = "";
        NextPanel.animate([{opacity: 0, left: "15%"},{opacity: 1, left: "0%"}], {duration: window.AnimateBlockerDuration});

        setTimeout(function()
        {
            whichcontainer.style.overflow = "";
            if(functiontocall != null)
            {
                functiontocall();
            }

        }, window.AnimateBlockerDuration);

    }, window.AnimateBlockerDuration * 2.5);
}

window.MovePanelInsideContainerBack = function(CurrentPanel, PreviousPanel, whichcontainer, functiontocall)
{
    whichcontainer.style.overflow = "hidden";
    CurrentPanel.style.opacity = 0;
    CurrentPanel.style.left = "15%";
    CurrentPanel.animate([{opacity: 1, left: "0%"},{opacity: 0, left: "15%"}], {duration: window.AnimateBlockerDuration});

    setTimeout(function()
    {
        CurrentPanel.style.position = "absolute";
        CurrentPanel.style.display = "none";
        CurrentPanel.style.left = "105%";

        PreviousPanel.style.opacity = 1;
        PreviousPanel.style.left = "0%";
        PreviousPanel.style.position = "relative";
        PreviousPanel.style.display = "";
        PreviousPanel.animate([{opacity: 0, left: "-15%"},{opacity: 1, left: "0%"}], {duration: window.AnimateBlockerDuration});

        setTimeout(function()
        {
            whichcontainer.style.overflow = "";
            if(functiontocall != null)
            {
                functiontocall();
            }

        }, window.AnimateBlockerDuration);
    }, window.AnimateBlockerDuration * 2.5);
}

window.FadeOutInInsideContainer = function(CurrentPanel)
{
    CurrentPanel.style.opacity = 0;
    CurrentPanel.animate([{opacity: 1},{opacity: 0}], {duration: window.AnimateBlockerDuration});

    setTimeout(function()
    {
        CurrentPanel.style.opacity = 1;
        CurrentPanel.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateBlockerDuration});

    }, window.AnimateBlockerDuration * 2.5);
}

window.OpenPanelAnimate = function(PanelContainer, BackBlocker)
{
    if(PanelContainer != null)
    {
        PanelContainer.animate([{bottom: "-100%"},{bottom: 0}], {duration: window.AnimateBlockerDuration});
    }
    BackBlocker.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateBlockerDuration});
    BackBlocker.style.opacity = 1;
}

window.ClosePanelAnimate = function(PanelContainer, BackBlocker, functiontocall)
{
    if(PanelContainer != null)
    {
        PanelContainer.animate([{bottom: 0},{bottom: "-100%"}], {duration: window.AnimateBlockerDuration});
    }
    BackBlocker.animate([{opacity: 1},{opacity: 0}], {duration: window.AnimateBlockerDuration});
    BackBlocker.style.opacity = 0;

    setTimeout(function()
    {
        BackBlocker.remove();

        if(functiontocall != null)
        {
            functiontocall();
        }

    }, window.AnimateBlockerDuration);
}


// ================================= SCROLL WINDOW ====================================

window.ScrollToWindow = function(whichsectiontogo)
{
    window.scrollTo
    ({
        top: whichsectiontogo.offsetTop,
        behavior: "smooth"
    });
}

// =============================== INSTANTIATED PANEL & DROP DOWN RELATED FUNCTION ==================================


document.onclick = function (e)
{
    if (!window.OpenPanelsList || window.OpenPanelsList.length === 0) return;

    let clickedInsideIndex = -1;

    for (let i = 0; i < window.OpenPanelsList.length; i++)
    {
        if (window.OpenPanelsList[i].contains(e.target))
        {
            clickedInsideIndex = i;
        }
    }

    if (clickedInsideIndex !== -1)
    {
        // Close only child panels above
        for (let i = window.OpenPanelsList.length - 1; i > clickedInsideIndex; i--)
        {
            window.OpenPanelsList[i].remove();
            window.OpenPanelsList.pop();
        }
    }
    else
    {
        // Click outside → close everything
        window.closeAllPanels();
        // window.RotateToggle("", true);
    }
};


// Remove panels starting from a specific panel
window.removePanelsFrom = function(panel)
{
    const index = window.OpenPanelsList.indexOf(panel);

    if (index !== -1)
    {
        for (let i = window.OpenPanelsList.length - 1; i >= index; i--)
        {
            window.OpenPanelsList[i].remove();
            window.OpenPanelsList.pop();
        }
    }
};

// Close all panels
window.closeAllPanels = function()
{
    while (window.OpenPanelsList.length > 0)
    {
        let panel = window.OpenPanelsList.pop();
        panel.remove();
    }
};


window.FunctionCheckInstantiateDropDown = function(thisdropdownid, WhereToInstantiate)
{
    let ThisPanelID = "DropDownPanel" + thisdropdownid;
    let CheckExistingSamePanel = document.getElementById(ThisPanelID);
    // If Already Exist Remove it ------------------------------------------------
    if(CheckExistingSamePanel)
    {
        window.removePanelsFrom(CheckExistingSamePanel);
        return null;
    }

    // Remove unrelated Panels Except The Parents ----------------------------------------
    while (window.OpenPanelsList.length > 0)
    {
        let topPanel = window.OpenPanelsList[window.OpenPanelsList.length - 1];

        if (topPanel.contains(WhereToInstantiate))
        {
            break; // keep parent -----------------
        }

        topPanel.remove();
        window.OpenPanelsList.pop();
    }

    // Create DropDown Panel Container -----------------------------------
    let ThisDropDownContainerFlex = document.createElement("div");
    ThisDropDownContainerFlex.className = "ContainerFlex";
    ThisDropDownContainerFlex.id = ThisPanelID;
    WhereToInstantiate.append(ThisDropDownContainerFlex);

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainerFlex.append(DropDownContainer);

    window.InstantiateDropDownLoading(DropDownContainer, 6)

    // Register Panel to List ---------------------------------------------
    window.OpenPanelsList.push(ThisDropDownContainerFlex);

    return ThisDropDownContainerFlex
}

window.InstantiateDropDownLoading = function(whichdropdown, howmanyinstantiate)
{
    const RandomTexts = ["Random Longer", "Lorem Ipsum", "Random Longest Text", "RandomMid"];
    

    for(let i = 0; i < howmanyinstantiate; i++)
    {
        let RandomTextToInstantiate = RandomTexts[Math.floor(Math.random() * RandomTexts.length)];

        let DropDownSelectionContainer = document.createElement("div");
        DropDownSelectionContainer.className = "DropDownSelectionContainer";
        whichdropdown.append(DropDownSelectionContainer);

        let DropDownText = document.createElement("div");
        DropDownText.className = "MidSizeText3 DropDownSelectionText loading_grey";
        DropDownText.innerHTML = RandomTextToInstantiate;
        DropDownText.style.width = "fit-content";
        DropDownText.style.color = "transparent";
        DropDownSelectionContainer.append(DropDownText);
    }
}

window.ScrollToSelectedDropDown = function(DropDown, Selected)
{
    if (DropDown && Selected)
    {
        const dropdownTop = DropDown.scrollTop;
        const dropdownBottom = dropdownTop + DropDown.clientHeight;

        const selectedTop = Selected.offsetTop;
        const selectedBottom = selectedTop + Selected.offsetHeight;

        DropDown.scrollTop = selectedTop;
        return

        if (selectedTop < dropdownTop)
        {
            DropDown.scrollTop = selectedTop;
        }
        else if (selectedBottom > dropdownBottom)
        {
            DropDown.scrollTop = selectedBottom - DropDown.clientHeight;
        }
    }
}


// ================================ PROVINCE AND CITY REGION =========================================

window.ProvinceData = [];
window.CityRegionData = [];

window.PrepareProvinceDropDown = function(event, provincedropdowncontainer, provinceinput, thisdropdownid, cityregiondropdown, cityregioninput, functiontocall)
{
    event.preventDefault();
    event.stopPropagation();

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown(thisdropdownid, provincedropdowncontainer);

    if(ThisDropDownContainer == null)
    {
        return
    }

    if(window.ProvinceData.length == 0)
    {
        // let LoadingBlocker = InstantiateLoadingBlocker();

        fetch('/Assets/wilayah-indonesia/province.json')
        .then((response) => response.json())
        .then(function(data)
        {
            window.ProvinceData = data;
            console.log(window.ProvinceData);
            // LoadingBlocker.remove();

            InstantiateProvinceDropDown(provincedropdowncontainer, ThisDropDownContainer, provinceinput, cityregiondropdown, cityregioninput, ()=>functiontocall());
        });
    }
    else
    {
        InstantiateProvinceDropDown(provincedropdowncontainer, ThisDropDownContainer, provinceinput, cityregiondropdown, cityregioninput, ()=>functiontocall());
    }
}

function InstantiateProvinceDropDown(mainprovincecontainer, wheretoinstantiate, provinceinput, cityregiondropdown, cityregioninput, functiontocall)
{
    let CurrentSelectedProvince = mainprovincecontainer.getAttribute("which-province");

    // Remove The Loading and Immediately Instantiate Scroll Bar Again ----------------------------------------------------------
    wheretoinstantiate.innerHTML = "";

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    wheretoinstantiate.append(DropDownContainer);

    // Immediately Instantiate The List ----------------------------------------------------------

    let WhichCurrentDropDown = null;

    window.ProvinceData.forEach((thisprovdata) =>
    {
        let DropDownSelectionContainer = document.createElement("div");
        DropDownSelectionContainer.className = "DropDownSelectionContainer Selectable4";
        if(CurrentSelectedProvince == thisprovdata.id)
        {
            DropDownSelectionContainer.className = "DropDownSelectionContainer DropDownSelectionContainerSelected Selectable4";
            WhichCurrentDropDown = DropDownSelectionContainer;
        }

        DropDownSelectionContainer.onclick = function(event)
        {
            event.stopPropagation();

            // Apply Changes -------------------
            mainprovincecontainer.setAttribute("which-province", thisprovdata.id);
            mainprovincecontainer.setAttribute("which-name", thisprovdata.name);
            provinceinput.value = thisprovdata.text_display[window.CurrentCountryID];

            cityregiondropdown.setAttribute("which-city-region", "");
            cityregiondropdown.setAttribute("which-name", "-------");
            cityregiondropdown.className = "BasicInputFieldContainer";
            if(thisprovdata.id == "")
                cityregiondropdown.className = "BasicInputFieldContainer InputFieldContainerInvalid";
            cityregioninput.value = "-------";

            if(thisprovdata.id != CurrentSelectedProvince)
            {
                window.CityRegionData = []
            }
            
            // Remove The Drop Down -------------------
            window.removePanelsFrom(wheretoinstantiate);

            // Call The Function -------------------
            if (functiontocall)
                functiontocall();
        }
        DropDownContainer.append(DropDownSelectionContainer);

        let DropDownText = document.createElement("p");
        DropDownText.className = "MidSizeText3 DropDownSelectionText";
        DropDownText.innerHTML = thisprovdata.text_display[window.CurrentCountryID];
        DropDownSelectionContainer.append(DropDownText);
    });

    if(WhichCurrentDropDown != null)
    window.ScrollToSelectedDropDown(DropDownContainer, WhichCurrentDropDown)
}


window.PrepareCityRegionDropDown = function(event, cityregiondropdowncontainer, cityregioninput, thisdropdownid, provincedropdown, functiontocall)
{
    event.preventDefault();
    event.stopPropagation();

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown(thisdropdownid, cityregiondropdowncontainer);

    if(ThisDropDownContainer == null)
    {
        return
    }

    if(window.CityRegionData.length == 0)
    {
        let SelectedProvince = provincedropdown.getAttribute("which-province");
        
        fetch('/Assets/wilayah-indonesia/city-region/' + SelectedProvince + '.json')
        .then((response) => response.json())
        .then(function(data)
        {
            window.CityRegionData = data;
            console.log(window.CityRegionData);

            InstantiateCityRegionDropDown(ThisDropDownContainer, cityregiondropdowncontainer, cityregioninput, ()=>functiontocall())
        });
    }
    else
    {
        InstantiateCityRegionDropDown(ThisDropDownContainer, cityregiondropdowncontainer, cityregioninput, ()=>functiontocall());
    }
}

function InstantiateCityRegionDropDown(wheretoinstantiate, cityregiondropdown, cityregioninput, functiontocall)
{
    let CurrentSelectedCityRegion = cityregiondropdown.getAttribute("which-city-region");

    // Remove The Loading and Immediately Instantiate Scroll Bar Again ----------------------------------------------------------
    wheretoinstantiate.innerHTML = "";

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    wheretoinstantiate.append(DropDownContainer);

    // Immediately Instantiate The List ----------------------------------------------------------
    let WhichCurrentDropDown = null;

    window.CityRegionData.forEach((thiscityregiondata) =>
    {
        let DropDownSelectionContainer = document.createElement("div");
        DropDownSelectionContainer.className = "DropDownSelectionContainer Selectable4";
        if(CurrentSelectedCityRegion == thiscityregiondata.id)
        {
            DropDownSelectionContainer.className = "DropDownSelectionContainer DropDownSelectionContainerSelected Selectable4";
            WhichCurrentDropDown = DropDownSelectionContainer;
        }
        DropDownSelectionContainer.onclick = function(event)
        {
            event.stopPropagation();

            // Apply Changes -------------------

            cityregiondropdown.setAttribute("which-city-region", thiscityregiondata.id);
            cityregiondropdown.setAttribute("which-name", thiscityregiondata.name);
            cityregioninput.value = thiscityregiondata.text_display[window.CurrentCountryID];
            
            // Remove The Drop Down -------------------
            window.removePanelsFrom(wheretoinstantiate);

            // Call The Function -------------------
            if (functiontocall)
                functiontocall();
        }
        DropDownContainer.append(DropDownSelectionContainer);

        let DropDownText = document.createElement("p");
        DropDownText.className = "MidSizeText3 DropDownSelectionText";
        DropDownText.innerHTML = thiscityregiondata.text_display[window.CurrentCountryID];
        DropDownSelectionContainer.append(DropDownText);

        if(WhichCurrentDropDown != null)
        window.ScrollToSelectedDropDown(DropDownContainer, WhichCurrentDropDown)
    });
}


// ================================ GENDER ======================================

window.InstantiateGenderDropDown = function(event, wheretoinstantiate, genderinput, thisdropdownid, functiontocall)
{
    event.preventDefault();
    event.stopPropagation();

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown(thisdropdownid, wheretoinstantiate);

    if(ThisDropDownContainer == null)
    {
        return
    }

    let CurrentSelectedGender = wheretoinstantiate.getAttribute("which-gender");

    // Remove The Loading and Immediately Instantiate Scroll Bar Again ----------------------------------------------------------
    ThisDropDownContainer.innerHTML = "";

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);

    // Immediately Instantiate The List ----------------------------------------------------------
    let WhichCurrentDropDown = null;

    window.GenderChoicesJSON.forEach((thisgenderdata) =>
    {
        let DropDownSelectionContainer = document.createElement("div");
        DropDownSelectionContainer.className = "DropDownSelectionContainer Selectable4";
        if(CurrentSelectedGender == thisgenderdata.which_value)
        {
            DropDownSelectionContainer.className = "DropDownSelectionContainer DropDownSelectionContainerSelected Selectable4";
            WhichCurrentDropDown = DropDownSelectionContainer;
        }
        DropDownSelectionContainer.onclick = function(event)
        {
            event.stopPropagation();

            // Apply Changes -------------------

            wheretoinstantiate.setAttribute("which-gender", thisgenderdata.which_value);
            genderinput.value = thisgenderdata.translation[window.CurrentCountryID];
            
            // Remove The Drop Down -------------------
            window.removePanelsFrom(ThisDropDownContainer);

            // Call The Function -------------------
            if (functiontocall)
                functiontocall();
        }
        DropDownContainer.append(DropDownSelectionContainer);

        let DropDownText = document.createElement("p");
        DropDownText.className = "MidSizeText3 DropDownSelectionText";
        DropDownText.innerHTML = thisgenderdata.translation[window.CurrentCountryID];
        DropDownSelectionContainer.append(DropDownText);

        if(WhichCurrentDropDown != null)
        window.ScrollToSelectedDropDown(DropDownContainer, WhichCurrentDropDown)
    });
}



// ================================ CHECK URL VALIDITY ========================================

window.CheckIsValidURL = function(urlinput, whattype)
{
   let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
       '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
       '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
       '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
       '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
       '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

    if(whattype == "TikTok")
    {
        pattern = /^https?:\/\/(www\.)?tiktok\.com\/(@[a-zA-Z0-9._]+|[^\/]+\/video\/\d+)/i;
    }
    else if(whattype == "Instagram")
    {
        pattern = /^https?:\/\/(www\.)?instagram\.com\/([a-zA-Z0-9._]+(\/)?|(?:p|reel|stories|tv)\/[a-zA-Z0-9_-]+)(\?.*)?$/i;
    }
    else if(whattype == "Google Maps")
    {
        pattern = /^https?:\/\/(?:(?:www\.)?google\.[a-z.]+\/maps(?:\/(?:place|dir|search|@|embed))?|(?:www\.)?google\.[a-z.]+\/maps(\?.+)?|goo\.gl\/maps|maps\.app\.goo\.gl)\/?.*$/i;
    }
    else if(whattype == "Email")
    {
        pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }

   return !!pattern.test(urlinput);
}


// ============================== DETERMINE SIZE ==================================

window.DetermineSizeFile = function(thisfile)
{
    let _size = thisfile;
    
    let fSExt = new Array('Bytes', 'KB', 'MB', 'GB'), i=0;
    while(_size>900)
    {
        _size/=1024;
        i++;
    }
    let exactSize = (Math.round(_size*100)/100)+' '+fSExt[i];
    return exactSize;
}



// ============================ CONVERT FORMDATA TO JSON ==============================

window.ConvertFormDataToJSON = function(formData)
{
    let formDataJSON = {};
    formData.forEach((value, key) =>
    {
        if (formDataJSON[key])
        {
            if (Array.isArray(formDataJSON[key]))
            {
                formDataJSON[key].push(value);
            }
            else
            {
                formDataJSON[key] = [formDataJSON[key], value];
            }
        }
        else
        {
            formDataJSON[key] = value;
        }
    });
    return formDataJSON;
}

// ===================================== NOTIFICATION =======================================

window.DisplayWarningUpload = function(whatstatus, whatmessage)
{
    if(document.getElementById('WarningPanelContainer')== null)
    {
        let WarningPanelContainer = document.createElement("div");
        WarningPanelContainer.className = "WarningPanelContainer";
        WarningPanelContainer.id = "WarningPanelContainer";
        document.getElementsByTagName("body")[0].append(WarningPanelContainer);
    }

    let WarningPanelSendStatus = document.createElement("div");
    WarningPanelSendStatus.className = "WarningPanelSendStatus "+ whatstatus;
    document.getElementById('WarningPanelContainer').append(WarningPanelSendStatus);

    let WarningPanelIconContainer = document.createElement("div");
    WarningPanelIconContainer.className = "WarningPanelIconContainer";
    WarningPanelSendStatus.append(WarningPanelIconContainer);

    let WarningPanelIcon = document.createElement("img");
    WarningPanelIcon.className = "WarningPanelIcon";
    WarningPanelIconContainer.append(WarningPanelIcon);

    let WarningPanelTextMessage = document.createElement("p");
    WarningPanelTextMessage.className = "WarningPanelTextMessage InterMediumTextFont";
    WarningPanelTextMessage.innerHTML = whatmessage;
    WarningPanelSendStatus.append(WarningPanelTextMessage);

    let NotificationMessageTime = document.createElement("p");
    NotificationMessageTime.className = "NotificationMessageTime InterRegularTextFont";
    NotificationMessageTime.innerHTML = window["NowTxt" + window.CurrentCountryID];
    WarningPanelSendStatus.append(NotificationMessageTime);

    AnimateAndRemovingWarningPanel(WarningPanelSendStatus);
}

function AnimateAndRemovingWarningPanel(whichpanel)
{
    whichpanel.animate([{opacity: 0, right: "-15%"},{opacity: 1, right: 0}], {duration: 300});
    whichpanel.style.opacity = 1;
    whichpanel.style.left = 0;

    setTimeout(function()
    {
        whichpanel.animate([{opacity: 1, left: 0}, {opacity: 0, left: "-15%"}], {duration: 300});
        whichpanel.style.opacity = 0;
        whichpanel.style.left ="15%";
        setTimeout(function()
        {
            whichpanel.remove();
            var WarningPanelSendStatus = document.querySelectorAll('.WarningPanelSendStatus');

            if(WarningPanelSendStatus.length == 0)
            {
                document.getElementById('WarningPanelContainer').remove();
            }
        }, 300);
    }, 2000);
}


// ==================================== LOADING BLOCKER ================================

window.InstantiateLoadingBlocker = function(blockerid)
{
    let WaitingBlockerChecHotelDetails = document.createElement("div");
    WaitingBlockerChecHotelDetails.className = "BasicBlackBlocker";
    WaitingBlockerChecHotelDetails.id = blockerid;
    document.getElementsByTagName("body")[0].append(WaitingBlockerChecHotelDetails);

    let WaitingClockAnimated = document.createElement("img");
    WaitingClockAnimated.className = "WaitingClockAnimated";
    WaitingClockAnimated.src = process.env.PUBLIC_URL + "/Assets/images/Icon/waiting-clock-icon.svg";
    WaitingBlockerChecHotelDetails.append(WaitingClockAnimated);

    return WaitingBlockerChecHotelDetails;
}


// ================================== PREPARE UI ELEMENTS =====================================

window.PrepareBasicElement = function(lang)
{
    window.GetAndSetCountryID(lang);

    PrepareBasicUILang(lang);
    PrepareBasicButtonFunction();
}

function PrepareBasicUILang()
{
    let HelpCenterBtnText = document.getElementById("HelpCenterBtnText") // Help Center ------------------------------------
    if(HelpCenterBtnText != null)
        HelpCenterBtnText.innerHTML = window["HelpCenterTxt" + window.CurrentCountryID];

    let HelpCenterBtnMobileText = document.getElementById("HelpCenterBtnMobileText") // Help ------------------------------------
    if(HelpCenterBtnMobileText != null)
        HelpCenterBtnMobileText.innerHTML = window["HelpTxt" + window.CurrentCountryID];
}

function PrepareBasicButtonFunction()
{

    // ------------------------ CONTACT US ---------------------------------
    let ContactUsHref = document.querySelectorAll('.ContactUsHref');
    ContactUsHref.forEach(thistext =>
    {
        thistext.href = "https://pingingo.com/contactus/" + window.CurrentCountryID;
        thistext.target = '_blank';
        thistext.rel = 'noopener noreferrer';
    });

    // ------------------------ ABOUT US ---------------------------------
    let AboutUsHref = document.querySelectorAll('.AboutUsHref');
    AboutUsHref.forEach(thistext =>
    {
        thistext.href = "https://pingingo.com/about/" + window.CurrentCountryID;
        thistext.target = '_blank';
        thistext.rel = 'noopener noreferrer';
    });
    
    // ------------------------ TERMS AND CONDITION ---------------------------------
    let TermsConditionHref = document.querySelectorAll('.TermsConditionHref');
    TermsConditionHref.forEach(thistext =>
    {
        thistext.href = "https://pingingo.com/termsandcondition/" + window.CurrentCountryID;
        thistext.target = '_blank';
        thistext.rel = 'noopener noreferrer';
    });
    
    // ------------------------ PRIVACY ---------------------------------
    let PrivacyHref = document.querySelectorAll('.PrivacyHref');
    PrivacyHref.forEach(thistext =>
    {
        thistext.href = "https://pingingo.com/privacy/" + window.CurrentCountryID;
        thistext.target = '_blank';
        thistext.rel = 'noopener noreferrer';
    });
    
    // ------------------------ FAQ ---------------------------------
    let FAQHref = document.querySelectorAll('.FAQHref');
    FAQHref.forEach(thistext =>
    {
        thistext.href = "https://pingingo.com/frequentaskquestion/" + window.CurrentCountryID;
        thistext.target = '_blank';
        thistext.rel = 'noopener noreferrer';
    });
    
    // ------------------------ LISTING ---------------------------------
    let ListingMitraHREF = document.querySelectorAll('.ListingMitraHREF');
    ListingMitraHREF.forEach(thistext =>
    {
        thistext.href = "https://listing.pingingo.com/" + window.CurrentCountryID;
        thistext.target = '_blank';
        thistext.rel = 'noopener noreferrer';
    });
    
    // ------------------------ LISTING ---------------------------------
    let BlogHREF = document.querySelectorAll('.BlogHREF');
    BlogHREF.forEach(thistext =>
    {
        thistext.href = "https://blog.pingingo.com";
        thistext.target = '_blank';
        thistext.rel = 'noopener noreferrer';
    });
}


// ================================== GET AND SET COUNTRY ID ===========================================

window.GetAndSetCountryID = function(languagefromURL)
{
    if(languagefromURL != null && localStorage.getItem("current-cid") == null)
    {
        window.CurrentCountryID = languagefromURL;
    }

    if(localStorage.getItem("current-cid") == null) // If No Local Storage -------------------
    {
        localStorage.setItem("current-cid", window.CurrentCountryID);
    }
    else if(localStorage.getItem("current-cid") != null)  // If Local Storage Exist and URL Null -------------------
    {
        window.CurrentCountryID = localStorage.getItem("current-cid");
    }

    // Change The URL Based On Language If Exist ------------------------

    window.CurrentAvailableLang =
[
    {
        "LanguageName":"Bahasa Indonesia",
        "code":"id",
        "FlagIcon":"/Assets/images/CountryCode/Indonesia.svg",
    },
    {
        "LanguageName":"English",
        "code":"en",
        "FlagIcon":"/Assets/images/CountryCode/UnitedKingdom.svg",
    }
]

    let LocationPathName = window.location.pathname;
    let LocationPathList = LocationPathName.split('/').filter(Boolean);
    let LangExist = false;

    // Check if Language Exist On the URL --------------------------------------------

    for(let i = 0; i < window.CurrentAvailableLang.length; i++)
    {
        for(let j = 0; j < LocationPathList.length; j++)
        {
            if(window.CurrentAvailableLang[i].code == LocationPathList[j])
            {
                LocationPathList[j] = window.CurrentCountryID;
                LangExist = true;
            }
        }
    }

    if(LangExist == true)
    {
        let LatestURL = "";
        LocationPathList.forEach(thisarray =>
        {
            LatestURL = "/" + thisarray;
        });
        let obj =
        {
            Url: LatestURL
        };
        window.history.replaceState(obj, obj.Title, obj.Url);
    }

    // Reinstantiate The Top Panel --------------------------------------

    let LanguageChangeTopMenu = document.getElementById("LanguageChangeTopMenu");
    LanguageChangeTopMenu.innerHTML = "";

    let LangProfileIconDiv = document.createElement("div");
    LangProfileIconDiv.className = "TopCircleImageContainer BasicThinGreyBorder2 Selectable2";
    LangProfileIconDiv.onclick = function()
    {
        window.ChangeLangDropDown(LanguageChangeTopMenu);
    }
    LanguageChangeTopMenu.append(LangProfileIconDiv);

    let LangProfileIconImg = document.createElement("img");
    LangProfileIconImg.className = "ImageFullCover";
    LangProfileIconDiv.append(LangProfileIconImg);

    for(let i = 0; i < window.CurrentAvailableLang.length; i++)
    {
        if(window.CurrentAvailableLang[i].code == window.CurrentCountryID)
        {
            LangProfileIconImg.src = process.env.PUBLIC_URL + window.CurrentAvailableLang[i].FlagIcon;
        }
    }
}

window.ChangeLangDropDown = function(langtopcontainer)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    if(document.getElementById("TopLangDropDownContainer") != null)
    {
        window.PanelChoiceOpen.remove();
        window.PanelChoiceOpen = null;
    }
    else
    {
        if(window.PanelChoiceOpen != null)
        {
            window.PanelChoiceOpen.remove();
            window.PanelChoiceOpen = null;
        }

        window.PanelChoiceOpen = document.createElement("div");
        window.PanelChoiceOpen.className = "ContainerFlex ContainerFlex2";
        window.PanelChoiceOpen.id = "TopLangDropDownContainer";
        langtopcontainer.append(window.PanelChoiceOpen);

        let DropDownContainer = document.createElement("div");
        DropDownContainer.className = "DropDownContainer HideScrollBar";
        DropDownContainer.style.maxHeight = "none";
        DropDownContainer.style.right = 0;
        window.PanelChoiceOpen.append(DropDownContainer);

        for(let i = 0; i < window.CurrentAvailableLang.length; i++)
        {
            let LangDropDownButton = document.createElement("button");
            LangDropDownButton.className = "DropDownSelectionContainer Selectable4 ColumnGapBasic";

            if(window.CurrentCountryID == window.CurrentAvailableLang[i].code)
            {
                LangDropDownButton.className = "DropDownSelectionContainer DropDownSelectionContainerSelected ColumnGapBasic Selectable4";
                LangDropDownButton.onclick = function()
                {
                    window.event.preventDefault();
                    window.event.stopPropagation();
                    window.PanelChoiceOpen.remove();
                    window.PanelChoiceOpen = null;
                }
            }
            else
            {
                LangDropDownButton.onclick = function()
                {
                    window.event.preventDefault();
                    window.event.stopPropagation();
                    let WaitingRefreshBlocker = window.InstantiateLoadingBlocker("WaitingRefreshBlocker");
                    localStorage.setItem("current-cid", window.CurrentAvailableLang[i].code);
                    window.location.reload();
                }
            }
            DropDownContainer.append(LangDropDownButton);

            let LangDropDownIcon = document.createElement("img");
            LangDropDownIcon.className = "BigSizeIcon";
            LangDropDownIcon.src = process.env.PUBLIC_URL + window.CurrentAvailableLang[i].FlagIcon;
            LangDropDownButton.append(LangDropDownIcon);

            let LangDropDownText = document.createElement("p");
            LangDropDownText.className = "MidSizeText3 DropDownSelectionText";
            LangDropDownText.innerHTML = window.CurrentAvailableLang[i].LanguageName;
            LangDropDownButton.append(LangDropDownText);
        }
    }
}
